import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Planning } from '../../../classes/planning.class';
import { CodaltComponent } from '../../../codalt.component';
import { PlanningService } from '../../../services/planning/planning.service';
import { TracklinePlanningEditDialogComponent } from '../trackline-planning-edit-dialog/trackline-planning-edit-dialog.component';

@Component({
    selector: 'app-trackline-inventarisation-overview',
    standalone: false,
    templateUrl: './trackline-inventarisation-overview.component.html',
    styleUrl: './trackline-inventarisation-overview.component.scss',
})
export class TracklineInventarisationOverviewComponent extends CodaltComponent implements OnInit {
    plannings: Planning[] = [];

    print = false;

    fromDate: Date;
    toDate: Date;

    constructor(
        private planningService: PlanningService,
        private dialog: MatDialog
    ) {
        super();
    }

    ngOnInit(): void {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.toDate.setMonth(this.toDate.getMonth() + 12);

        this.subscriptions.add(
            this.planningService.getFilteredList(this.fromDate, this.toDate).subscribe(plannings => {
                this.plannings = plannings
                    .filter(
                        p =>
                            p.mainPlanning.entitytype_key === 'markings' &&
                            new Date(p.mainPlanning.begindate) > new Date() &&
                            (p.data?.behoefteInventarisatie || 0) >= 1
                    )
                    .sort((a, b) => {
                        const aDate = new Date(a.mainPlanning.begindate);
                        aDate.setDate(aDate.getDate() - (a.data?.behoefteInventarisatie || 0));
                        const bDate = new Date(b.mainPlanning.begindate);
                        bDate.setDate(bDate.getDate() - (b.data?.behoefteInventarisatie || 0));
                        return aDate.getTime() - bDate.getTime();
                    });
            })
        );
    }

    openPlanning(planning: Planning) {
        this.dialog.open(TracklinePlanningEditDialogComponent, {
            disableClose: true,
            data: {
                planning,
            },
            panelClass: 'planning-edit-dialog',
        });
    }
}
